import React, {useContext, useEffect, useState} from 'react';
import {Col, Form, Modal, Row} from "@themesberg/react-bootstrap";
import fetchWrapper from "../../utils/fetch/fetchWrapper";
import DataTable from "react-data-table-component";
import 'react-data-table-component-extensions/dist/index.css';

const ChatDetails = ({showModal, setShowModal, id, setId, data}) => {

    const [dataDetails, setDataDetails] = useState([]);
    const [dataOrder, setDataOrder] = useState([]);
    

    // const fetchDataModal = (event) => {
    //     axios({
    //         method: "get",
    //         url: BASE_URL + "/find_order_items",
    //         headers: {
    //             'Authorization': token
    //         },
    //         data: {
    //             id: id,
    //         },
    //         timeout: 1000
    //     })
    //         .then(function (response) {
    //             console.log(response.data);
    //             if ((response.data.status = 200)) {
    //                 setDataDetails(response.data.orderItems)
    //             }
    //         })

    //         .catch(function (error) {
    //             console.log(error);
    //         });
    // }

    useEffect(() => {
        if (showModal) {
            fetchWrapper()
            .doGet({
                url: "/admin_messages?order_id=" + id,
                onSuccess: async (response) => {
                    setDataDetails(response.data.messages)
                    const orderData = data.filter(item => item.id === id);
                    setDataOrder(orderData)
                },
                onError: (response) => {},
            })
            .then(() => {})
            .catch((error) => {});
            // axios({
            //     method: "post",
            //     url: BASE_URL + "/find_order_items",
            //     headers: {
            //         'Authorization': token
            //     },
            //     data: {
            //         id: id,
            //     },
            //     timeout: 5000
            // })
            //     .then(function (response) {
            //         console.log(response.data);
            //         if ((response.data.status = 200)) {
            //             console.log(response.data)
            //             setDataDetails(response.data.orderItems)
            //             setDataOrder(response.data.order)
            //             setDataHistoricStatus(response.data.orderSequence)
            //         }
            //     })

            //     .catch(function (error) {
            //         console.log(error);
            //     });
        }

    }, [showModal]);

    // const dataOnChange = (e) => {
    //     setDataForm({
    //         ...dataForm,
    //         [e.target.name]: e.target.value
    //     })
    // }
    // const tableData = {
    //     columnItem,
    //     dataDetails
    // };
    const handleClose = () => {
        setShowModal(false);
        setId(null)
        // setDataForm({})
    }
    const clientColumns = [
        {
            name: "ID del Cliente",
            selector: "client_id",
            wrap: true,
        },
        {
            name: "Nombre",
            selector: "client",
        },
        {
            name: "Apellido",
            selector: "client_lastname",
        },
        {
            name: "Color",
            cell: row => (
                <div style={{ color: 'blue' }}>Azul</div>
              ),
            wrap: true,
            grow: 2
        },
        
    ];
    const columnItem = [
        {
            name: "Mensajes",
            selector: "text",
            cell: row => {
              const senderObjectClient = data.find(item => item.client_id === row.user._id);
              const senderObjectEmployee = data.find(item => item.employee_id === row.user._id);
              let textColor = "black";
        
              if (senderObjectClient) {
                textColor = "blue";
              } else if (senderObjectEmployee) {
                textColor = "green";
              }
        
              return (
                <div style={{ color: textColor }}>
                  {row.text}
                </div>
              );
            }
        },
        {
            name: "Usuario",
            selector: "user._id",
            sortable: true,
            cell: row => {
                const senderObjectClient = data.find(item => item.client_id === row.user._id);
                let senderName = "Nombre desconocido";
                if (senderObjectClient){
                    senderName = senderObjectClient ? `${senderObjectClient.client} ${senderObjectClient.client_lastname}` : "Nombre desconocido";
                }
                else{
                    const senderObjectEmployee = data.find(item => item.employee_id === row.user._id);
                    senderName = senderObjectEmployee ? `${senderObjectEmployee.employee} ${senderObjectEmployee.employee_lastname}` : "Nombre desconocido";
                }
                return <div>{senderName}</div>;
              }
        },
        {
            name: "Fecha de envío",
            selector: "createdAt",
            sortable: true,
            wrap: true,
            grow: 1,
            cell: row => {
              const date = new Date(row.createdAt);
              const year = date.toLocaleString("es-ES", { year: "numeric", month: "numeric", day: "numeric"});
              const time = date.toLocaleString("es-ES", { hour: "numeric", minute: "numeric", second: "numeric" });
        
              return (
                <div>
                  <div>Fecha: {year}</div>
                  <div>Hora: {time}</div>
                </div>
              );
            }
          },
    ];
    const cleanerColumns = [
        {
            name: "ID del Cleaner",
            selector: "employee_id",
            wrap: true,
        },
        {
            name: "Nombre",
            selector: "employee",
        },
        {
            name: "Apellido",
            selector: "employee_lastname",
        },
        {
            name: "Color",
            cell: row => (
                <div style={{ color: 'green' }}>Verde</div>
              ),
            wrap: true,
            grow: 2
        },
        
    ];
    return (
        <Modal show={showModal} onHide={() => handleClose()}

               size="xl"
               aria-labelledby="contained-modal-title-vcenter"
               centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Detalles deL CHAT
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* <div className="row">
                    <div className="col-md-10">
                        <h4>ID: {id}</h4>
                    </div>
                    <div className="col-md-10">
                        <h4>Direccion: {dataOrder.address}</h4>
                    </div>
                    <div className="col-md-10">
                        <h4>Estado del pedido: {dataOrder.state}</h4>
                    </div>
                    <div >
                        <h5>Subtotal: ${dataOrder.subtotal}</h5>
                        <h5>Despacho: ${dataOrder.dispatch_price}</h5>
                        {dataOrder.discount == null ?
                            <>
                                <h5>Descuento: $0</h5>
                            </> : <>
                                <h5>Descuento: ${dataOrder.discount}</h5>
                            </>

                        }
                        <h5>Total: ${dataOrder.total}</h5>
                    </div>
                </div> */}
                <div>
                    <h4>Numero de orden: {id}</h4>
                </div>
                <DataTable
                    columns={clientColumns}
                    data={dataOrder}
                />
                <DataTable
                    columns={cleanerColumns}
                    data={dataOrder}
                />                
                <div className="row mt-5 ">
                    <h4>Chat:</h4>

                    <DataTable
                        columns={columnItem}
                        data={dataDetails}
                        pagination
                        noHeader
                        paginationPerPage={10}
                    />
                </div>
                {/* </DataTableExtensions> */}
                {/* <Row>
                    <Col md={12} className="mb-3">
                      <Form.Group id="firstName">
                        <Form.Label>Categoria</Form.Label>
                        <Form.Control onChange={dataOnChange} value={dataForm.hasOwnProperty("title") ? dataForm.title : ''} name="title" type="text" placeholder="Ingresa tu categoria" required/>
                      </Form.Group>
                    </Col>
                  </Row> */}
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-light" onClick={() => handleClose()}>Cerrar</button>
            </Modal.Footer>
        </Modal>


    );
};

export default ChatDetails
